(function () {

  const ORDER = ["XXS","XS","S","M","L","XL","XXL","3XL","4XL","5XL"];

  function getOrder(value) {
  if (!value) return 999;

  const v = value.toUpperCase().trim();

  // Acepta 36.5 y 36,5
  const num = v.replace(",", ".");
  if (/^\d+(\.\d+)?$/.test(num)) return parseFloat(num);

  const idx = ORDER.indexOf(v);
  return idx !== -1 ? idx : 999;
}

  function applyOrder(root = document) {

    /* =========================
       1️⃣ Globo Grid + PDP
    ========================== */
    root.querySelectorAll(
      '.swatch--gl[data-option-index="1"] li.swatches-options, \
       .swatch--gl[data-option-index="1"] li.select-option'
    ).forEach(li => {

      if (
        li.classList.contains('swatches-more') ||
        li.dataset.value === "Default"
      ) return;

      const span = li.querySelector('.attr-title-hover');
      if (!span) return;

      li.style.order = getOrder(span.textContent);
    });

    /* =========================
       2️⃣ Quick Add Modal
    ========================== */
    root.querySelectorAll(
      'variant-picker fieldset[data-fieldset-index="1"]'
    ).forEach(fieldset => {

      fieldset.style.display = "flex";
      fieldset.style.flexWrap = "wrap";

      fieldset.querySelectorAll(
        'label.variant-option__button-label'
      ).forEach(label => {

        const input = label.querySelector('input[type="radio"]');
        if (!input || input.value === "Default") return;

        label.style.order = getOrder(input.value);
      });
    });

  }

  /* =========================
     Ejecutar en primera carga
  ========================== */
  window.addEventListener("load", () => {
    setTimeout(() => applyOrder(), 400);
  });

  /* =========================
     Observer GLOBAL pero inteligente
     (solo reacciona a variant-picker
      o swatch--gl nuevos)
  ========================== */
  const observer = new MutationObserver((mutations) => {

    for (const m of mutations) {
      for (const node of m.addedNodes) {

        if (!(node instanceof HTMLElement)) continue;

        if (
          node.matches?.('variant-picker') ||
          node.querySelector?.('variant-picker') ||
          node.matches?.('.swatch--gl') ||
          node.querySelector?.('.swatch--gl')
        ) {
          applyOrder(node);
        }

      }
    }

  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();